import React from 'react';
import {CONTRACT_LIST, GATE_LIST, MAPPED_MATERIAL, BARCODE_HISTORY, ASSETS_VERIFICATION} from "./type";

const initalState = {
    contractList: [],
    gateList: [],
    material: [],
    barcodeHistoryResponse: [],
    siteVerification: []
};

const contractAssetsMapping = (state = initalState, action) => {
    const {type, payload} = action;
    switch (type) {
        case CONTRACT_LIST:
            return {
                ...state,
                contractList: payload,
            };
        case GATE_LIST:
            return {
                ...state,
                gateList: payload,
            };
        case MAPPED_MATERIAL:
            return {
                ...state,
                material: payload,
            };
        case BARCODE_HISTORY:
            return {
                ...state,
                barcodeHistoryResponse: payload,
            };
        case ASSETS_VERIFICATION:
            return {
                ...state,
                siteVerification: payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default contractAssetsMapping
